export const AUTH_STATUS = {
    FAILURE: 'failure',
    SUCCESS: 'success',
    RECOVERY: 'recovery'
};
